import React from 'react';

import Icon from '../Icon';

import mapModifiers from 'utils/functions';

interface LoadingProps {
  variant?: 'fullScreen' | 'default' | 'abs';
  isShow?: boolean;
  isFill?: boolean;
  size?: 'small' | 'default';
  isWhite?: boolean;
  isTransparent?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
  isShow = false,
  variant,
  isFill,
  size,
  isWhite,
  isTransparent
}) => {
  if (!isShow) return null;
  return (
    <div className={mapModifiers('a-loading', variant, isFill && 'filled', size, isWhite && 'white', isTransparent && 'isTransparent')}>
      <div className="a-loading_wrapper">
        <Icon iconName="spinner" size={size === 'default' ? '45' : '16'} />
      </div>
    </div>
  );
};

Loading.defaultProps = {
  variant: 'default',
  isShow: false,
  isFill: false,
  size: 'default',
};

export default Loading;
